import React from 'react'
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'

const MarkdownRenderer = ({ children }) => {
	return <ReactMarkdown plugins={[gfm]}>{children}</ReactMarkdown>
}

export default MarkdownRenderer
